<template>
  <div>
    <Form
      page-title="Add a new Menu"
      buttonName="Submit"
      :businessId="businessId"
      :isCreateMode="true"
      :isInList="isInList"
      @submit="submit"
      ref="menusForm"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { createMenu } from "@/API/MenusAPIs";
import { getUserInfo } from "@/helpers/getUserInfo";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Create",
  props: ["isInList", "businessId"],
  components: { Form },
  data() {
    return {
      loading: false
    };
  },

  methods: {
    async submit(formData) {
      const { UserID } = getUserInfo(this.$store);
      const CreateData = {
        locales: formData.locales,
        type: formData.type,
        business_id: formData.businessId,
        user_id: UserID
      };

      const callback = () => {
        this.$refs.menusForm.resetForm();
      };
      submitAndNotify(
        this,
        createMenu({ businessId: formData.businessId, data: CreateData }),
        callback
      );
    }
  }
};
</script>
<style></style>
